"use client";

import { Clock, AlertTriangle, BarChart3 } from "lucide-react";
import { useI18n } from "@/lib/i18n/I18nProvider";

export function ProblemStatement(): JSX.Element {
  const { t } = useI18n();

  const PROBLEMS = [
    {
      icon: Clock,
      title: t("landing.problems.p1Title"),
      description: t("landing.problems.p1Desc"),
    },
    {
      icon: AlertTriangle,
      title: t("landing.problems.p2Title"),
      description: t("landing.problems.p2Desc"),
    },
    {
      icon: BarChart3,
      title: t("landing.problems.p3Title"),
      description: t("landing.problems.p3Desc"),
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-2xl mx-auto">
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-keiront-obsidian mb-4">
            {t("landing.problems.title")}
          </h2>
        </div>

        <div className="space-y-6">
          {PROBLEMS.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <div key={index} className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-50">
                    <Icon className="w-6 h-6 text-keiront-danger" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-keiront-obsidian mb-2">
                    {problem.title}
                  </h3>
                  <p className="text-slate-600">{problem.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
